import CT from '@marketplace-ai/tags';
import { ClaimsSortOptions } from './types';

export const MALPRACTICE_CLAIM_MIN_DATE = '1940-01-01';

export const HEADER_ROWS: { label: string; sortKey: ClaimsSortOptions; cyTag: string }[] = [
  {
    label: 'Occurrence Date',
    sortKey: 'occurrence_date',
    cyTag: CT.malpracticeInsurance.table.sortCompany,
  },
  {
    label: 'Claim Status',
    sortKey: 'claim_status',
    cyTag: CT.malpracticeInsurance.table.sortPolicyNumber,
  },
  {
    label: 'Settlement Amount',
    sortKey: 'settlement_amt',
    cyTag: CT.malpracticeInsurance.table.sortPeriod,
  },
  {
    label: 'Liability Carrier',
    sortKey: 'liability_carrier',
    cyTag: CT.malpracticeInsurance.table.sortStatus,
  },
];

export const CLAIM_STATUS_OPTIONS = [
  { label: 'Pending', value: 'Pending' },
  { label: 'Settled', value: 'Settled' },
  { label: 'Arbitrated', value: 'Arbitrated' },
  { label: 'Award', value: 'Award' },
  { label: 'In Appeal', value: 'In Appeal' },
  { label: 'Adjudicated', value: 'Adjudicated' },
  { label: 'Withdrawn', value: 'Withdrawn' },
  { label: 'Dismissed', value: 'Dismissed' },
  { label: 'Other', value: 'Other' },
];

export const PROVIDER_INVOLVEMENT_OPTIONS = [
  { label: 'Primary Defendant', value: 'Primary Defendant' },
  { label: 'Co-defendant', value: 'Co-defendant' },
];

export const emptyMalpracticeClaimForm = {
  id: undefined,
  providerInvolvement: { label: '', value: '' },
  claimStatus: { label: '', value: '' },
  liabilityCarrier: '',
  settlementAmt: undefined,
  allegationsTxt: '',
  allegedInjuryTxt: '',
  occurrenceDate: '',
  claimDate: '',
  settlementDate: '',
  details: '',
};

export const SETTLED_CLAIM_STATUSES = [
  'Arbitrated',
  'Settled',
  'Award',
  'Adjudicated',
  'Withdrawn',
  'Dismissed',
  'Other',
];
